<template>
  <div>
    <PageHeader :title="tituloPagina" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="row">
            <span class="mb-2" v-html="textoInicial"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabela && !loading">
      <div class="card">
        <div class="card-body">
          <div>
            <b-table responsive="sm" :items="dadosInfoBancarias" :fields="camposInfoBancarias" per-page="1000" striped>
              <template #cell(options)="data">
                <div class="d-flex justify-content-end">
                  <b-button size="sm" class="me-1" variant="primary"
                    @click="editarInfoBancarias(data.item); alterarTexto()" data-tooltip="Editar"
                    data-tooltip-location="bottom">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button size="sm" class="me-1" variant="danger" @click="excluirInfoBancarias(data.item)"
                    data-tooltip="Excluir" data-tooltip-location="bottom" :disabled="data.item.STPRINCIPAL == 'S'">
                    <i class="mdi mdi-trash-can"></i>
                  </b-button>
                </div>
              </template>
              <template #cell(tornePrincipal)="data">
                <b-button size="sm" class="me-1 btn-info" @click="tornePrincipal(data.item)"
                  data-tooltip-location="bottom" v-if="data.item.STPRINCIPAL !== 'S'">
                  Tornar Principal
                </b-button>
              </template>
            </b-table>
            <div class="row">
              <div class="mt-1 d-flex justify-content-end">
                <b-button variant="success" class="mt-5 mb-3 me-3" @click="incluir(); alterarTexto()">
                  <i class="mdi mdi-plus"></i>
                  Incluir
                </b-button>
                <b-button class="button-icon mt-5 mb-3 btn-info d-flex justify-content-center align-items-center"
                  variant="success" @click="salvarTodasContas"
                  :disabled="disabledSalvar || !dadosInfoBancarias || dadosInfoBancarias.length === 0"
                  data-tooltip="Salvar" data-tooltip-location="bottom">
                  <i class='fs-4 mr-5 mdi mdi-check-underline'></i>
                  <span class="ml-5">Salvar</span>
                  <b-spinner variant="primary" small class="ms-2" v-if="loadingSalvar"></b-spinner>
                </b-button>
                <b-spinner variant="primary" small class="ms-2" v-if="loadingSalvar"></b-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!tabela && !loading">
      <div class="">
        <div class="card">
          <div class="card-body">
            <p>
              Caso o seu Banco ou Agência não esteja disponível, entre em contato
              com a Unicampo para efetuar o cadastramento.
            </p>
            <div class="row">
              <div class="col-md-6">
                <b-form-group class="mb-3" label="Banco">
                  <multiselect v-model="selectBanco" placeholder="Selecione" :show-labels="false" :allow-empty="false"
                    label="nm_bco" :options="optionBanco" @input="carregarAgencias" />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group class="mb-3" label="Agência">
                  <multiselect v-model="selectAgencia" placeholder="Selecione" :show-labels="false" :allow-empty="false"
                    label="nm_agencia" :options="optionAgencia" :loading="loadingAgencias">
                    <span slot="noResult">Selecione um Banco.</span>
                    <span slot="noOptions">Selecione um Banco.</span>
                  </multiselect>
                </b-form-group>
              </div>

            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group class="mb-3" label="N° da Conta">
                  <b-form-input v-model="nrConta" trim v-mask="'##########'" autocomplete="off" maxlength="10"
                    type="text"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-2 d-flex">
                <b-form-group class="mb-3" label="DV">
          <b-form-input v-model="dvConta" trim autocomplete="off" :maxlength="dvMaxLength" min="0" type="text"
            @input="validateValue"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group class="mb-3" label="Tipo de Conta">
                  <multiselect v-model="selectTipoConta" placeholder="Selecione" :show-labels="false"
                    :allow-empty="false" label="label" :options="optionTipoConta" />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="row">
                <div class="mt-1 d-flex justify-content-between">
                  <b-button class="mt-1 me-1" @click="tabela = true; resetarTexto()" data-tooltip="Voltar"
                    data-tooltip-location="bottom">
                    <i class="mdi mdi-arrow-left-circle font-size-15"></i>
                  </b-button>
                  <b-button class="button-icon mt-1 me-1 d-flex justify-content-center align-items-center" variant="success" @click="salvarContaBancaria" :disabled="disabledSalvar"
                    data-tooltip="Salvar" data-tooltip-location="bottom">
                    <i class='fs-4 mr-5 mdi mdi-check-underline'></i>
                    <span class="ml-5">Salvar Editar</span>
                    <b-spinner variant="primary" small class="ms-2" v-if="loadingSalvar"></b-spinner>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import store from "@/store";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  components: {
    PageHeader,
    Multiselect,
  },

  data() {
    return {
      tituloPagina: 'Atualização Cadastral',
      optionBanco: [],
      optionAgencia: [],
      textoInicial: 'Olá Cooperado(a),<br/><br/> Percebemos que as suas informações bancárias estão desatualizadas ou ainda não foram cadastradas. Por favor, atualize-as agora, pois é uma informação essencial para início e continuidade no Projeto. </br></br>  ATENÇÃO: as informações salvas como <strong> Principal Sim </strong> no formulário abaixo serão usadas para meio de pagamento de Honorários, Adiantamento, Sobras, Fundo Rotativo, dentre outros.',
      textoAdicional: 'Olá Cooperado(a)! <br/><br/> Percebemos que suas informações bancárias estão desatualizadas ou ainda não foram cadastradas. Por favor, atualize-as agora, pois é uma informação essencial para o início do seu projeto.</br> ATENÇÃO: as informações salvas como <strong> Principal Sim </strong> no formulário abaixo serão usadas para meio de pagamento de Honorários, Adiantamento, Sobras, Fundo Rotativo, dentre outros.',
      optionTipoConta: [
        {
          tp_conta: "C",
          label: "Conta Corrente",
        },
        {
          tp_conta: "P",
          label: "Poupança",
        },
      ],

      selectBanco: {},
      selectAgencia: {},
      nrConta: "",
      dvConta: "",
      selectTipoConta: {},
      stPrincipal: "",
      disabledPrincipal: "",
      camposInfoBancarias: [
        {
          key: "NMBCO",
          label: "Banco",
          formatter: (value, row, column) => {
            return column.CDBCO + " - " + capitalizeString(value);
          },
        },
        {
          key: "NMAGENCIA",
          label: "Agência",
          formatter: (value, row, column) => {
            return (
              column.NRAGENCIA +
              "-" +
              column.DVAGENCIA +
              " " +
              capitalizeString(value)
            );
          },
        },
        {
          key: "NRCTA",
          label: "Conta",
        },
        {
          key: "DVCTA",
          label: "DV",
        },
        {
          key: "CONTA",
          label: "Tipo de Conta",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
        {
          key: 'tornePrincipal',
          label: "",
        },
      ],
      dadosInfoBancarias: [],
      loading: true,
      tabela: true,
      avancar: null,
      loadingSalvar: false,
      disabledSalvar: false,
      loadingAgencias: false,
      disabledCampo: false,
    };
  },

    computed: {
      dvMaxLength() {
        if (!this.selectBanco || !this.selectBanco.nm_bco) return 1;
        const nomeBanco = this.selectBanco.nm_bco.toLowerCase();
        const bancosPermitidos = [
          "hsbc",
          "citibank",
          "agiplan",
          "agipag"
        ];
        return bancosPermitidos.some(banco => nomeBanco.includes(banco)) ? 2 : 1;
      }
    },

    watch: {
      selectBanco(newBanco) {
        if (!newBanco || !newBanco.nm_bco) {
          this.dvConta = "";
          return;
        }
        const nomeBanco = newBanco.nm_bco.toLowerCase();
        const bancosPermitidos = ["hsbc", "citibank", "agiplan", "agipag"];
        if (!bancosPermitidos.some(banco => nomeBanco.includes(banco))) {
          this.dvConta = "";
        }
      }
    },

  async created() {
    await this.buscarInfoBancarias();
    await this.verificaSituacaoBancaria();
  },

  methods: {
    async verificaSituacaoBancaria() {
      try {
        const tpPessoa = store.state.me.tp_Pessoa.cd_tp_pessoa;
        const respSituacao = await this.$http.get("api/cadastroCandidato/verificaInfoBancaria");
        if (respSituacao.status === 200 && tpPessoa === "5") {
          this.$store.dispatch("setInfoBancaria", false);
          localStorage.setItem("validacao-info-bancaria", 'false');
        }
      } catch (error) {
        this.handleForbiddenError(error);
      }
    },

    cargoPessoa() {
      const cargoIds = store.state.me?.tp_Pessoa?.sq_cargo || [];
      return cargoIds.includes("33");
    },

    handleForbiddenError(error) {
      const { response } = error;
      if (response && response.status === 403) {
        if (this.cargoPessoa()) {
          console.log("Entrou no if", this.cargoPessoa());
          this.$store.dispatch("setInfoBancaria", true);
          localStorage.setItem("validacao-info-bancaria", "true");
          this.$router.push("/");
        } else {
          this.$store.dispatch("setInfoBancaria", true);
          localStorage.setItem("validacao-info-bancaria", "true");
          this.$router.push("/");
        }
      } else {
        console.error("Erro inesperado:", error);
      }
    },

    resetarTexto() {
      this.textoInicial = 'Olá Cooperado(a),</br> </br> Percebemos que as suas informações bancárias estão desatualizadas ou ainda não foram cadastradas. Por favor, atualize-as agora, pois é uma informação essencial para início e continuidade no Projeto. </br> ATENÇÃO: as informações salvas como <strong> Principal Sim </strong> no formulário abaixo serão usadas para meio de pagamento de Honorários, Adiantamento, Sobras, Fundo Rotativo, dentre outros.';
    },
    alterarTexto() {
      this.textoInicial = this.textoAdicional;
    },
    async buscarInfoBancarias() {
      this.loading = true;
      this.dadosInfoBancarias = [];
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarInfoBancarias"),
        this.$http.get("api/cadastroCandidato/buscarLkpBancos"),
      ]).then(([responseInfoBancarias, responseLkpBanco]) => {
        this.dadosInfoBancarias = responseInfoBancarias.data;
        this.optionBanco = responseLkpBanco.data.map((item) => {
          return {
            ...item,
            nm_bco: item.cd_bco + " - " + capitalizeString(item.nm_bco),
          };
        });

        if (this.dadosInfoBancarias.length == 0) {
          this.stPrincipal = true;
          this.disabledPrincipal = true;
        } else {
          this.stPrincipal = false;
          this.disabledPrincipal = "";
        }
      });
      this.loading = false;
    },

    async tornePrincipal(item) {
      const numeroDaConta = item.NRCTA;
      await this.$http.put(`api/cadastroCandidato/tornarContaPrincipal/${numeroDaConta}`)
        .then(() => {
          this.loading = true;
          this.$tools.alerta("A conta selecionada foi alterada para principal", "success");
          Promise.all([
            this.$http.get("api/cadastroCandidato/buscarInfoBancarias"),
            this.$http.get("api/cadastroCandidato/buscarLkpBancos"),
          ]).then(([responseInfoBancarias, responseLkpBanco]) => {
            this.dadosInfoBancarias = responseInfoBancarias.data;
            this.optionBanco = responseLkpBanco.data.map((item) => {
              return {
                ...item,
                nm_bco: item.cd_bco + " - " + capitalizeString(item.nm_bco),
              };
            });
            if (this.dadosInfoBancarias.length == 0) {
              this.stPrincipal = true;
              this.disabledPrincipal = true;
            } else {
              this.stPrincipal = false;
              this.disabledPrincipal = "";
            }
            this.loading = false;
          });

        })
        .catch(err => {
          // Exibe uma mensagem de erro
          this.$tools.alerta(err.response.data.message, "error");
        });
      this.loading = false;
    },
    async carregarAgencias() {
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      this.selectAgencia = null;
      this.optionAgencia = [];
      this.loadingAgencias = true;
      try {
        const response = await this.$http.get(
          "api/cadastroCandidato/buscarLkpAgencia/" + this.selectBanco.cd_bco
        );
        this.optionAgencia = response.data.map((item) => {
          return {
            ...item,
            nm_agencia:
              item.nr_agencia +
              "-" +
              item.dv_agencia +
              " " +
              capitalizeString(item.nm_agencia),
          };
        });
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      } finally {
        this.loadingAgencias = false;
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },

    async salvarContaBancaria() {
      this.loadingSalvar = true;
      this.disabledSalvar = true;

      if (!this.validarCampos()) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        return;
      }

      const item = this.montarObjetoConta();

      try {
        await this.salvarConta(item);
        this.$tools.alerta('Dados bancários salvos com sucesso!', "success");
        this.tabela = !this.tabela;
        this.buscarInfoBancarias();
      } catch (err) {
        this.$tools.alerta(err.response?.data?.message || "Erro ao salvar", "error");
      } finally {
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        this.isEditing = false;
      }
    },

    validarCampos() {
      return (
        this.selectBanco &&
        this.selectAgencia &&
        this.nrConta &&
        this.nrConta > 0 &&
        this.dvConta !== null &&
        this.selectTipoConta
      );
    },

    montarObjetoConta() {
      if (this.isEditing) {
        return {
          cd_bco: this.selectBanco.cd_bco,
          nr_agencia: this.selectAgencia.nr_agencia,
          nr_cta: this.nrConta,
          dv_cta: this.dvConta,
          tp_conta: this.selectTipoConta.tp_conta,
          st_principal: this.stPrincipal
        };
      } else {
        return {
          cdBanco: this.selectBanco.cd_bco,
          nrAgencia: this.selectAgencia.nr_agencia,
          nrConta: this.nrConta,
          dvConta: this.dvConta,
          tpConta: this.selectTipoConta.tp_conta,
          stPrincipal: 'S'
        };
      }
    },

    async salvarConta(informacoesBancarias) {
      if (this.isEditing) {
        await this.$http.put(`api/cadastroCandidato/atualizarInformacoesBancarias/${this.nrContaOriginal}`, informacoesBancarias);
      } else {
        await this.$http.post("api/cadastroCandidato/incluirInformacoesBancarias", informacoesBancarias);
      }
    },

    incluir() {
      this.disabledCampo = false;
      (this.selectBanco = ""),
        (this.selectAgencia = ""),
        (this.nrConta = ""),
        (this.dvConta = ""),
        (this.selectTipoConta = ""),
        (this.optionAgencia = []),
        (this.tabela = false);
      if (this.dadosInfoBancarias.length == 0) {
        this.stPrincipal = true;
        this.disabledPrincipal = true;
      } else {
        this.stPrincipal = false;
        this.disabledPrincipal = "";
      }
    },

    async editarInfoBancarias(data) {
      this.isEditing = true;

      this.disabledCampo = true;
      this.selectBanco = this.optionBanco.find((el) => el.cd_bco == data.CDBCO);
      this.nrContaOriginal = data.NRCTA;
      this.nrConta = data.NRCTA;
      this.dvConta = data.DVCTA;
      this.selectTipoConta = this.optionTipoConta.find(
        (el) => el.tp_conta == data.TPCONTA
      );
      this.stPrincipal = data.STPRINCIPAL;
            this.disabledPrincipal = data.STPRINCIPAL == "N" ? true : false;
      await this.carregarAgencias().then(() => {
        this.preencherAgencia(data.NRAGENCIA);
      });
      this.tabela = false;

      this.$router.push({ name: 'AtualizarInfoBancarias', params: { nrcta: this.nrConta } });
    },

    async salvarTodasContas() {
      this.loadingSalvar = true;
      this.disabledSalvar = true;

      try {
        const contaBancaria = this.dadosInfoBancarias.map((contaBancaria) => ({
          cdBanco: contaBancaria.CDBCO,
          nrAgencia: contaBancaria.NRAGENCIA,
          nrConta: contaBancaria.NRCTA,
          dvConta: contaBancaria.DVCTA,
          tpConta: contaBancaria.TPCONTA,
          stPrincipal: contaBancaria.STPRINCIPAL,
        }));

        await this.$http.post("api/cadastroCandidato/incluirInformacoesBancarias", contaBancaria);

        this.$tools.alerta('Dados bancários salvos com sucesso!', "success");

        this.tabela = !this.tabela;
        this.buscarInfoBancarias();
        localStorage.removeItem("validacao-info-bancaria");
        this.$emit("carregarNivelPerfil");
        this.$store.commit("INFO_BANCARIA", true);
        this.$router.push("/");
      } catch (err) {
        this.$tools.alerta(err.message, "error");
      } finally {
        this.loadingSalvar = false;
        this.disabledSalvar = false;
      }
    },

    preencherAgencia(nrAgencia) {
      this.selectAgencia = this.optionAgencia.find(
        (el) => el.nr_agencia == nrAgencia
      );
    },

    async excluirInfoBancarias(data) {
      var item = {};
      item.cdBanco = data.CDBCO;
      item.nrAgencia = data.NRAGENCIA;
      item.nrConta = data.NRCTA;
      try {
        await this.$http.post(
          "api/cadastroCandidato/excluirInformacoesBancarias",
          item
        );
      } catch (err) {
        this.$tools.alerta(err.response.data.message, "error");
      } finally {
        this.buscarInfoBancarias();
        this.$tools.alerta("Exclusão efetuado com sucesso!", "success");

      }
    },

    validateValue() {
      if (this.dvConta < 0) {
        this.dvConta = 0;
      }
    },
  },
};
</script>

<style scoped>
  .button-icon i {
    margin-right: 5px;
  }
</style>
